import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TestListState {
  data: any[];
  loading: boolean;
  error: string | null;
  lastPage: number | null;
  page: number;
  filters: {
    testTypes?: any[];
    testBehaviors?: any[];
  };
}

const initialState: TestListState = {
  data: [],
  loading: false,
  error: null,
  lastPage: null,
  page: 1,
  filters: {},
};

const testListSlice = createSlice({
  name: "testList",
  initialState,
  reducers: {
    fetchTestListRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
      if (action.payload && action.payload.page) {
        state.page = action.payload.page;
      }
    },
    fetchTestListSuccess(
      state,
      action: PayloadAction<{ data: any[]; lastPage: number | null; filters?: any }>,
    ) {
      state.data = action.payload.data;
      state.lastPage = action.payload.lastPage;
      state.loading = false;
      state.error = null;
      if (action.payload.filters) {
        state.filters = {
          ...action.payload.filters,
        };
      }
    },
    fetchTestListFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    clearTestList(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.lastPage = null;
      state.page = 1;
      state.filters = {};
    },
    setTestListPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setTestListFilters(state, action: PayloadAction<any>) {
      state.filters = action.payload;
    },
  },
});

export const {
  fetchTestListRequest,
  fetchTestListSuccess,
  fetchTestListFailure,
  clearTestList,
  setTestListPage,
  setTestListFilters,
} = testListSlice.actions;

export default testListSlice.reducer;
